/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/space': {
    width: 52,
    height: 11,
    viewBox: '0 0 52 11',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M0 0h3.107v7.084h45.575V0h3.107V10.12H0V0z" _fill="#232323"/>'
  }
})
